import { getAllStripePlans } from './getAllStripePlans';

const initializeStripe = () => {
  getAllStripePlans();
};

export { initializeStripe };
